import type { EventTagDisplay } from './EventTagChips';

export const EVENT_TAG_IDS = {
  ENDED: 'evento_encerrado',
  SOLD_OUT: 'ingressos_esgotados',
  TRENDING: 'em_alta',
} as const;

export const EVENT_TAG_META: Record<
  string,
  { shortLabel: string; description: string }
> = {
  [EVENT_TAG_IDS.TRENDING]: {
    shortLabel: 'Em alta',
    description: 'Destaque escolhido pela equipe Meu Sacramento',
  },
  [EVENT_TAG_IDS.SOLD_OUT]: {
    shortLabel: 'Esgotado',
    description: 'Não há mais vagas ou ingressos disponíveis',
  },
  [EVENT_TAG_IDS.ENDED]: {
    shortLabel: 'Encerrado',
    description: 'Este evento já terminou',
  },
};

export function getTagShortLabel(tag: EventTagDisplay): string {
  return EVENT_TAG_META[tag.id]?.shortLabel ?? tag.label;
}

export function getTagDescription(tag: EventTagDisplay): string {
  return EVENT_TAG_META[tag.id]?.description ?? tag.label;
}

export function hasEventTag(tags: EventTagDisplay[] | undefined, id: string): boolean {
  return (tags ?? []).some((t) => t.id === id);
}

export function isEventEndedTag(tags: EventTagDisplay[] | undefined): boolean {
  return hasEventTag(tags, EVENT_TAG_IDS.ENDED);
}

export function isEventSoldOutTag(tags: EventTagDisplay[] | undefined): boolean {
  return hasEventTag(tags, EVENT_TAG_IDS.SOLD_OUT);
}
